(() => {
  if (window.__roadSpecSearchSynonymsLoaded) return;
  window.__roadSpecSearchSynonymsLoaded = true;

  const corrections = [
    [/\breciever\b/gi, 'receiver'],
    [/\binfotainmant\b/gi, 'infotainment'],
    [/\bmiror\b/gi, 'mirror'],
    [/\bamplifer\b/gi, 'amplifier'],
    [/\bclim[a-z]*e\b/gi, 'climate'],
    [/\bbrakee?\b/gi, 'brake'],
  ];
  const synonyms = [
    [/\bradio\b/i, 'receiver'],
    [/\bhead\s+unit\b/i, 'receiver'],
    [/\binfotainment\b/i, 'receiver'],
    [/\b(?:screen|monitor)\b/i, 'display'],
    [/\babs\b/i, 'brake module'],
    [/\bdriver(?:\s+side)?\b/i, 'left'],
    [/\bpassenger(?:\s+side)?\b/i, 'right'],
  ];
  const track = (eventName, payload = {}) => {
    try { window.Shopify?.analytics?.publish(eventName, payload); } catch (_) {}
  };

  const enrich = (value) => {
    let query = String(value || '').replace(/\s+/g, ' ').trim();
    if (query.length < 2 || /\btag:(?:year|make):/i.test(query) || /^[a-z0-9-]{6,}$/i.test(query.replace(/\s/g, ''))) {
      return { query, changed: false, applied: [] };
    }
    const applied = [];
    corrections.forEach(([pattern, replacement]) => {
      if (pattern.test(query)) {
        query = query.replace(pattern, replacement);
        applied.push(replacement);
      }
    });
    synonyms.forEach(([pattern, replacement]) => {
      const firstTerm = replacement.split(' ')[0];
      if (pattern.test(query) && !new RegExp('\\b' + firstTerm + '\\b', 'i').test(query)) {
        query = query + ' ' + replacement;
        applied.push(replacement);
      }
    });
    return { query: query.replace(/\s+/g, ' ').trim(), changed: applied.length > 0, applied: [...new Set(applied)] };
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"], .rsp-global-search form');
    const input = form?.querySelector('input[name="q"]');
    if (!input) return;
    const result = enrich(input.value);
    if (!result.changed) return;
    input.value = result.query;
    track('roadspec_search_synonym_applied', {
      terms_added: result.applied,
      page_type: document.body.dataset.template || 'other',
    });
  }, true);

  // Some storefront navigation layers submit the form directly from the
  // button click. Normalize at click time as well so the native navigation
  // cannot bypass the synonym pass.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('form[role="search"] button[type="submit"], .rsp-global-search button[type="submit"]');
    const input = button?.closest('form')?.querySelector('input[name="q"]');
    if (!input) return;
    const result = enrich(input.value);
    if (!result.changed) return;
    input.value = result.query;
    track('roadspec_search_synonym_applied', {
      terms_added: result.applied,
      page_type: document.body.dataset.template || 'other',
    });
  }, true);
})();
